import { useEffect } from 'react'

import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import Form from '../../../../components/Form'
import Assignees from '../../../../components/Form/Items/Assignees'
import Attachments from '../../../../components/Form/Items/Attachment'
import Deadline from '../../../../components/Form/Items/Deadline'
import Description from '../../../../components/Form/Items/Description'
import Mandatory from '../../../../components/Form/Items/Mandatory'
import Title from '../../../../components/Form/Items/Title'
import FieldSelector from './Form/FieldSelector'

const DEFAULT_DATA = () => ({
  title: i18n.t(
    'processes.process_settings.wizard.tasks.types.request_general_information.form.defaults.title',
    {
      emoji: '\u{270D}',
    }
  ),
  description: `${i18n.t(
    'processes.process_settings.wizard.tasks.types.request_general_information.form.defaults.descriptions.1',
    { emoji: '\u{1F44B}' }
  )}<p><span><strong>${i18n.t(
    'processes.process_settings.wizard.tasks.types.request_general_information.form.defaults.descriptions.2'
  )}</strong></span>${i18n.t(
    'processes.process_settings.wizard.tasks.types.request_general_information.form.defaults.descriptions.3'
  )}`,
})

const Content = () => {
  const { associatedTaskItem: item, form, initializeForm } = useFormProvider()
  const defaultData = DEFAULT_DATA()

  useEffect(() => {
    initializeForm(DataCollectionCategories.generalInformation, {
      task_type: TaskConfigurationTypes.DataCollection,
      title: item ? item.title : defaultData.title,
      instruction: item ? item.instruction : defaultData.description,
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!form) return null

  return (
    <Form
      items={{
        title: <Title />,
        assignees: <Assignees onlyForAffectedUser readonly />,
        fieldSelector: <FieldSelector />,
        description: <Description />,
        deadline: <Deadline />,
        attachments: <Attachments />,
        mandatory: <Mandatory />,
      }}
    />
  )
}

export default Content
